import { createRoot } from 'react-dom/client';

import StandaloneApp from './StandaloneApp';
import { ErrorBoundary } from '@/components/error-boundary';
import { Router as WouterRouter } from 'wouter';

import './index.css';

createRoot(document.getElementById('root')!, {
  // Keeps caught errors off reportError(), which would raise the dev overlay.
  onCaughtError: (error, errorInfo) => {
    console.error(error, errorInfo.componentStack);
  },
}).render(
  <ErrorBoundary>
    <WouterRouter base={import.meta.env.BASE_URL.replace(/\/$/, '')}>
      <StandaloneApp />
    </WouterRouter>
  </ErrorBoundary>,
);
